React = require 'react'
t = require('views/internal/recup-with-helpers')('org_filtering')
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'

module.exports = class extends React.Component
  displayName: 'BoardListItemTagAddComponent'
  render: t.renderable ->
    { onClick, canAddTag } = @props

    if @props.canAddTag
      t.b onClick, class: 'board-tags-item mod-add', ->
        t.icon 'add',
          class: 'board-tags-item-icon'
    else
      t.text ''

  shouldComponentUpdate: naiveShouldComponentUpdate



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-tag-add-component.coffee